module.exports = __webpack_public_path__ + "static/media/2.81e48a11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/assets/2.jpg
// module id = 42
// module chunks = 0